import { breakpoints } from './constants';
import { Breakpoint } from '@/components/Media/types';

export function getBreakpointFromProps(props) {
    return Object.keys(breakpoints).find(breakpoint => !!props[breakpoint]) as Breakpoint;
}
